<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('wholesaleReceipt.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('wholesaleReceipt.pageTitle'),
            href: '/admin/wholesale-receipts'
          },
          {
            text: $t('create'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-md-4">
            <ts-loading-banner :loading="loading">
              <div
                class="ts-bg-gray-200 ts-border-blue-500 ts-rounded-md ts-p-2 ts-space-y-3"
              >
                <div class="row">
                  <div class="col-md-12">
                    <label class="required">{{ $t('wholesaleReceipt.date') }}</label>
                    <a-date-picker
                      v-model="model.payment_date"
                      format="DD-MM-YYYY"
                      valueFormat="DD-MM-YYYY"
                      class="ts-w-full"
                    ></a-date-picker>
                    <div class="validate" v-if="errors.has('payment_date')">
                      {{ errors.first('payment_date') }}
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <label>{{ $t('wholesaleReceipt.customer') }}</label>
                    <a-select
                      v-model="model.customer_id"
                      :options="customerList"
                      class="ts-w-full"
                      @change="onCustomerChange"
                      showSearch
                      :filterOption="
                        (input, option) =>
                          option.componentOptions.children[0].text
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                      "
                    ></a-select>
                    <!-- <input
                        v-model="model.customer_id" 
                        type="text" class="form-control" readonly /> -->
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <label class="required">{{
                      $t('wholesaleReceipt.invoice')
                    }}</label>
                    <a-select
                      v-model="model.stock_out_id"
                      :options="invoiceList"
                      @change="invoiceChange"
                      showSearch
                      :filterOption="
                        (input, option) =>
                          option.componentOptions.children[0].text
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                      "
                      class="ts-w-full"
                    ></a-select>
                    <div class="validate" v-if="errors.has('stock_out_id')">
                      {{ errors.first('stock_out_id') }}
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <label>{{ $t('wholesaleReceipt.grandTotal') }}</label>
                    <input
                      v-model="model.invoice_amount"
                      type="text"
                      class="form-control"
                      readonly
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <label class="required">{{
                      $t('wholesaleReceipt.amountPaid')
                    }}</label>
                    <input
                      v-model.number="model.amount_paid"
                      @input="amountPaid"
                      type="text"
                      class="form-control"
                    />
                    <div class="validate" v-if="errors.has('amount_paid')">
                      {{ errors.first('amount_paid') }}
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label class="required">{{
                      $t('wholesaleReceipt.amountDue')
                    }}</label>
                    <input
                      v-model="model.amount_due"
                      type="text"
                      class="form-control"
                      readonly
                    />
                    <div class="validate" v-if="errors.has('amount_due')">
                      {{ errors.first('amount_due') }}
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <label class="required">{{
                      $t('wholesaleReceipt.fxRate')
                    }}</label>
                    <input
                      v-model.number="model.fx_rate"
                      type="number"
                      step="any"
                      class="form-control"
                      readonly
                    />
                  </div>
                  <div class="col-md-6">
                    <label :class="allowPick ? 'required' : ''">{{
                      $t('wholesaleReceipt.nextPayment')
                    }}</label>
                    <a-date-picker
                      v-model="model.next_payment_date"
                      :disabled="!allowPick"
                      format="DD-MM-YYYY"
                      valueFormat="DD-MM-YYYY"
                      class="ts-w-full"
                    ></a-date-picker>
                    <div
                      class="validate"
                      v-if="errors.has('next_payment_date')"
                    >
                      {{ errors.first('next_payment_date') }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row ts-mt-2">
                <div class="col-md-12">
                  <PaymentMethod
                    v-model="model"
                    :validate="errors"
                    @loading="value => (loading = value)"
                  />
                </div>
              </div>
              <div class="row ts-mt-2">
                <div class="col-md-12">
                  <div
                    class="ts-bg-gray-200 ts-border-blue-500 ts-rounded-md ts-p-2 ts-space-y-3"
                  >
                    <div class="form-group">
                      <label>{{ $t('wholesaleReceipt.remark') }}</label>
                      <textarea
                        v-model="model.remark"
                        rows="3"
                        class="form-control"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col-md-12 ts-flex ts-space-x-3 ts-justify-end">
                  <ts-button
                    @click.prevent="
                      () => $router.push({ name: 'wholesale-receipt' })
                    "
                    >{{ $t('cancel') }}</ts-button
                  >
                  <ts-button
                    :waiting="waiting"
                    color="primary"
                    @click.prevent="onSave"
                    >{{ $t('save') }}</ts-button
                  >
                </div>
              </div>
            </ts-loading-banner>
          </div>
          <div class="col-md-8">
            <ts-preview-pdf v-model="waiting" :src="src"></ts-preview-pdf>
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { Errors } from 'form-backend-validation'
import PaymentMethod from './components/payment-method.vue'
import moment from 'moment'
export default {
  name: 'wholesaleReceipt',
  components: {
    PaymentMethod
  },
  data() {
    return {
      waiting: false,
      loading: false,
      src: '',
      errors: new Errors(),
      model: {
        payment_date: moment().format('DD-MM-YYYY'),
        stock_out_id: '',
        invoice_amount: '',
        amount_paid: '',
        amount_due: 0,
        fx_rate: '',
        next_payment_date: '',
        remark: '',
        customer_id: null,
        payment_method_id: 1,
        bank_name: null,
        account_number: null,
        account_name: null
      }
    }
  },
  created() {
    this.model.fx_rate = parseFloat(
      this.$store.state.authUser.sys_setting.fx_rate
    )
    this.loading = true
    this.fetchData().finally(() => (this.loading = false))
  },
  computed: {
    ...mapGetters('wholesale/receipt', ['filterInvoice', 'customerList']),
    allowPick() {
      return this.model.amount_due > 0
    },
    invoiceList() {
      return this.$store.state.wholesale.receipt.invoices
        .filter(el => el.amount_due > 0)
        .filter(el =>
          this.model.customer_id
            ? el.customer.customer_id == this.model.customer_id
            : true
        )
        .map(el => ({
          value: el.stock_out_id,
          label: el.invoice_no + '| $' + el.amount_due
        }))
    }
  },
  methods: {
    ...mapActions('wholesale/receipt', ['fetchData']),
    amountPaid() {
      this.model.next_payment_date = null
      this.model.amount_due = _.round(
        this.model.invoice_amount - this.model.amount_paid,
        2
      )
    },
    invoiceChange(value, options) {
      let result = this.filterInvoice(value)
      this.model.invoice_amount = result.amount_due
      this.model.customer_id = result.customer.customer_id
    },
    onSave() {
      this.waiting = true
      this.src = null
      this.$store
        .dispatch('wholesale/receipt/store', this.model)
        .then(response => {
          this.$store.commit('wholesale/receipt/UPDATE_AMOUNT_DUE', {
            stockOutId: this.model.stock_out_id,
            amount: this.model.amount_due
          })
          this.clearInput()
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onCustomerChange() {
      this.model.stock_out_id = ''
      this.model.invoice_amount = ''
      this.model.amount_paid = ''
      this.model.amount_due = 0
      this.model.next_payment_date = ''
      this.model.remark = ''
      this.model.payment_method_id = 1
      this.model.bank_name = null
      this.model.account_number = null
      this.model.account_name = null
    },
    clearInput() {
      this.model.payment_date = moment().format('DD-MM-YYYY')
      this.model.stock_out_id = ''
      this.model.invoice_amount = ''
      this.model.amount_paid = ''
      this.model.amount_due = 0
      this.model.next_payment_date = ''
      this.model.remark = ''
      this.model.customer_id = null
      this.model.payment_method_id = 1
      this.model.bank_name = null
      this.model.account_number = null
      this.model.account_name = null
    }
  }
}
</script>
